import _ from 'underscore';
import {logout}  from './OIDCService'
import urlConstant from '../constants/urlConstant';
import {store} from '../index'
import dataConstant from "../constants/dataConstants";

const CryptoJS = require("crypto-js");  

class CommonService 
{       
    httpGet = async (requestURL, authorizationRequired) => new Promise((resolve, reject) => {
        // const userresponse = JSON.parse(localStorage.getItem('user'))
        const userresponse = JSON.parse(localStorage.getItem('webappuser'))        

        const options = {
            method: 'get',
            headers: {
                'content-type': 'application/json; charset=UTF-8'
            }
        }

        if (authorizationRequired && userresponse) {
            // options.headers.Authorization = `bearer ${userresponse.UserId} ${userresponse.AccessToken}`
            options.headers.Authorization = `bearer ${userresponse.accesstoken}`
        }
        
        fetch(requestURL, options)
            .then(response => {
                if(response.status === 404 || response.status === 400|| response.status === 500){
                    this.AddErrorLog(response.status,response.url)                                                                     
                }    
                if (response.status === 404 || response.status === 200 || response.status === 400) {
                    return response.json()
                  }
                  return response
            }, err => {
                reject(err);
            }).then(responseJson => {
                if(responseJson.status === 401){
                    // localStorage.removeItem('webappuser')                     
                    logout()                                                                       
                }  
                resolve(responseJson);
            }, err => {
                this.AddErrorLog(err.message,err.stack)
                reject(err);
            }).catch(err => {
                this.AddErrorLog(err.message,err.stack)
                reject(err);
            });
    });

    httpPost = async (requestURL, requestBody, authorizationRequired) => new Promise((resolve, reject) => {      
        // const userresponse = JSON.parse(localStorage.getItem('user'))
        const userresponse = JSON.parse(localStorage.getItem('webappuser'))

        const options = {
            method: 'post',
            headers: {
                'content-type': 'application/json; charset=UTF-8'
            },
            body: JSON.stringify(requestBody)
        }

        if (authorizationRequired && userresponse) {
            // options.headers.Authorization = `CustomBasic ${userresponse.UserId} ${userresponse.Token}`
            options.headers.Authorization = `bearer ${userresponse.accesstoken}`
        }
        
        fetch(requestURL, options)
            .then(response => {
                if(response.status === 404 || response.status === 400 || response.status === 500){
                    this.AddErrorLog(response.status,response.url)                                                                     
                }    
                if (response.status === 404 || response.status === 200 || response.status === 400) {
                    return response.json()
                  }
                  return response    
            }, err => {
                reject(err);
            }).then(responseJson => {   
                if(responseJson.status === 401){
                    // localStorage.removeItem('webappuser')                      
                    logout()                                                                       
                }     
                resolve(responseJson);
            }, err => {
                this.AddErrorLog(err.message,err.stack)
                reject(err);
            }).catch(err => {
                this.AddErrorLog(err.message,err.stack)
                reject(err);
            });

    });

    DocumentUpload = async(requestURL, formData, authorizationRequired) => new Promise((resolve, reject) => {
        const userresponse = JSON.parse(localStorage.getItem('webappuser'))

        const options = {
            method: 'post',
            headers: {
                'Accept': 'application/json',
            },
            body: formData
        }

        if (authorizationRequired && userresponse) {
            // options.headers.Authorization = `CustomBasic ${userresponse.UserId} ${userresponse.Token}`
            options.headers.Authorization = `bearer ${userresponse.accesstoken}`
        }

        fetch(requestURL, options)
            .then(response => {
                if(response.status === 404 || response.status === 400 || response.status === 500){
                    this.AddErrorLog(response.status,response.url)                                                                     
                }    
                if (response.status === 404 || response.status === 200 || response.status === 400) {
                    return response.json()
                  }
                  return response    
            }, err => {
                reject(err);
            }).then(responseJson => {   
                if(responseJson.status === 401){
                    // localStorage.removeItem('webappuser')                      
                    logout()                                                                       
                }          
                resolve(responseJson);
            }, err => {
                this.AddErrorLog(err.message,err.stack)
                reject(err);
            }).catch(err => {
                this.AddErrorLog(err.message,err.stack)
                reject(err);
            });
    })

    AddErrorLog = (message,stack) => {
        const { user } = store.getState()
        const ErrorData = {
          Message: message,
          Stack: stack,
          ErrorFrom:"WebApp",
          TenantGuid: user?.TenantGuid
        }
        const userData = JSON.parse(localStorage.getItem('webappuser'))
        // this.httpPost(urlConstant.ErrorLog.AddErrorLog, ErrorData, true)
        fetch(urlConstant.ErrorLog.AddErrorLog, {            
            method: 'Post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${userData.accesstoken}`,
            },
            body: JSON.stringify(ErrorData)
        })
        .then(response => {
            console.log(response);
          },
            err => {
              console.log(err);
            }).catch(err => {
              console.log(err)
            });
      }

    SetMenuList = (Role, callback) => {
        // const { dispatch } = this.props;
      if (Role) {
        const userData = JSON.parse(localStorage.getItem('webappuser'));
            this.httpGet(`${urlConstant.Menu.GetMenuData}?Role=${Role}`, true)
            .then(response => {
                if (response) {
                if (response.Value) {                      
                    let menuTopData ="" 
                    // Not display panelConfiguration menu on tous login (Client)
                    if(Role === dataConstant.RoleType.Client)
                    {
                        const { hostname } = window.location
                        if (hostname && hostname.indexOf("tous") > -1) {
                            // const PanelConfiguration = _.find(response.Value, function (item) { return item.key === "PanelConfiguration" })
                            const index = response.Value.indexOf(_.find(response.Value, function (item) { return item.key === "PanelConfiguration" }));
                            if(index > -1){
                                response.Value.splice(index, 1)
                              }
                        }                      
                    }      
                    if(Role === dataConstant.RoleType.Supplier)
                    {
                        _.each(response.Value,(i) => {
                            if(i.key && i.key.toLowerCase() === dataConstant.RefType.Inward.toLowerCase()){
                                i.title = dataConstant.Exports
                            }
                        });
                    }
                  // Auditor entity display 
                    if (Role === dataConstant.RoleType.Auditor)
                    {
                      if (userData.RefType === dataConstant.RoleType.Wholesaler)
                      {
                        _.each(response.Value, (e) => {
                          if (e.key && e.key === "Entities") {
                            _.each(e.children, (i) => {
                              if (i.key && i.key.toLowerCase() === dataConstant.Menu.Wholesalers.toLowerCase()) {
                                i.title = dataConstant.Menu.Factory
                                i.key = dataConstant.Menu.Key
                                i.url = dataConstant.Menu.URL
                              }
                            });
                          }
                        });
                      }                      
                    }                  
                    menuTopData = response.Value;
                    localStorage.setItem('menuTopData', JSON.stringify(menuTopData));
                    if(callback)
                        callback();
                }
                }
            }, err => {
                console.log(err);
            }).catch(err => {
                console.log(err);
            })
            .finally(() => {
                
            });
        }
      }

         // for DecryptData
      DecryptData =(data) =>{       
        const strKey = 'fl!23net@%$$2!@#';
        const key = CryptoJS.enc.Utf8.parse(strKey);
        const iv = CryptoJS.enc.Utf8.parse(strKey);
        const decrypted = CryptoJS.AES.decrypt(
          data,
          key,
          {
              iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
          }
        );
        return decrypted.toString(CryptoJS.enc.Utf8);
      };

    // for encyptdata
    EncryptData = (data) => {
    const strKey = 'fl!23net@%$$2!@#';
    const key = CryptoJS.enc.Utf8.parse(strKey);
    const iv = CryptoJS.enc.Utf8.parse(strKey);
    const encdata = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key,
    {
    keySize: 128 / 8,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
    });
    return encdata.toString();
    };

    toDataUrl = (url, callback) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
          const reader = new FileReader();
          reader.onloadend = function () {
            const newURL = reader.result.replace("data:application/octet-stream;base64,", "data:image/png;base64,")
            callback(newURL);
          }
          reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
      }
      
}
export default CommonService
